import React from 'react';
import { Link } from 'react-router-dom';

const OfflineIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
);

const LiveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11.623 7.603l6.062 3.5c0.479 0.276 1.090 0.112 1.365-0.366 0.277-0.478 0.113-1.090-0.365-1.365l-6.062-3.5c-0.479-0.276-1.090-0.112-1.366 0.365s-0.112 1.089 0.366 1.366zM17.186 11.969l-6.062-3.5-3.5 6.062 6.062 3.5 3.5-6.062zM6.123 17.129l6.062 3.5c0.478 0.276 1.090 0.112 1.365-0.366s0.112-1.090-0.365-1.365l-6.062-3.5c-0.479-0.276-1.090-0.112-1.366 0.365-0.277 0.478-0.112 1.090 0.366 1.366zM27.012 19.951l-11.076-5.817-1 1.732 10.576 6.683c0.717 0.414 1.635 0.169 2.049-0.549s0.168-1.635-0.549-2.049zM16.033 25c0-0.553-0.448-1-1-1h-9c-0.553 0-1 0.447-1 1 0 0.552 0 1 0 1l-1.033-0.021 0.033 1.021h13l0.047-0.958-0.984-0.042c0 0-0.063-0.448-0.063-1z" />
    </svg>
);

const RepairIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
);


function HomePage() {
    return (
        <div className="home">
            <header className="home-header">
                <img src="/logos/seriea.png" alt="Serie A Logo" />
                <h1>VibeFanta</h1>
                <p>La tua piattaforma definitiva per l'asta del Fantacalcio.</p>
            </header>
            <main className="home-grid">
                <Link to="/asta-offline" className="home-card">
                    <div className="home-card-icon"><OfflineIcon /></div>
                    <h2>Asta Offline📵</h2>
                    <p>Gestisci la tua asta manualmente, con un'interfaccia semplice e intuitiva.</p>
                </Link>
                <Link to="/asta-online" className="home-card">
                    <div className="home-card-icon"><LiveIcon /></div>
                    <h2>Asta Live🛜</h2>
                    <p>Partecipa a un'asta in tempo reale con offerte, timer e un banditore virtuale.</p>
                </Link>
                <Link to="/asta-online" className="home-card">
                    <div className="home-card-icon"><RepairIcon /></div>
                    <h2>Asta di Riparazione❄️</h2>
                    <p>Migliora la tua squadra a metà stagione con il mercato di riparazione.</p>
                </Link>
            </main>
        </div>
    );
}

export default HomePage;